export default "__VITE_ASSET__DAmyp1$2__"